import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=87937e12&scoped=true&"
import script from "./Estatisticas.vue?vue&type=script&lang=js&"
export * from "./Estatisticas.vue?vue&type=script&lang=js&"
import style0 from "./Estatisticas.vue?vue&type=style&index=0&id=87937e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87937e12",
  null
  
)

export default component.exports